import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { Helmet } from 'react-helmet';
import BannerSlide from './BannerSlide';

function Home() {
  const consultantImages = [
    '/gabriela-rodriguez.jpg',
    '/gabriela-rodriguez-1.jpg',
    '/lab1.jpeg',
    '/field2.jpeg',
  ];
  const [consultantImageIndex, setConsultantImageIndex] = useState(0);

  useEffect(() => {
    const consultantInterval = setInterval(() => {
      setConsultantImageIndex((prevIndex) => (prevIndex + 1) % consultantImages.length);
    }, 5000);

    return () => {
      clearInterval(consultantInterval);
    };
  }, [consultantImages.length]);

  return (
    <div className="home-page-wrapper">
      <Helmet>
        <title>Sol de Vainilla | Con Vainilla Siempre Sí!! - Consultoría y Productos</title>
        <meta
          name="description"
          content="Sol de Vainilla: Asesoría técnica especializada en plantaciones de vainilla en Costa Rica, México, Guatemala, Honduras, Nicaragua y otros. Productos 100% costarricenses."
        />
      </Helmet>

      {/* Hero Banner Slider */}
      <BannerSlide />

      {/* Expert Section matching reference image */}
      <section className="home-expert-section">
        <div className="container">
          <div className="expert-showcase-card">
            {/* Left: Circular Image with Gold Ring and Flower Badge */}
            <div className="expert-avatar-column">
              <div className="avatar-frame-outer">
                <img
                  src={consultantImages[consultantImageIndex]}
                  alt="Gabriela Rodríguez Hernández - Especialista en Vainilla"
                  className="expert-portrait-img"
                />
                <div className="avatar-flower-badge" title="Sol de Vainilla">
                  <span>❀</span>
                </div>
              </div>
            </div>

            {/* Right: Clean Info Card */}
            <div className="expert-text-column">
              <span className="expert-kicker">CONOCE A NUESTRA EXPERTA</span>
              <h2 className="expert-heading">en Vainilla</h2>

              <div className="expert-flower-divider">
                <span className="divider-dot"></span>
                <span className="divider-icon">❀</span>
                <span className="divider-dot"></span>
              </div>

              <h3 className="expert-name">Gabriela Rodríguez Hernández</h3>
              <p className="expert-bio-p">
                Bióloga y consultora con amplia experiencia en el cultivo, biotecnología y beneficiado de vainilla.
                Ha brindado asesoría técnica a plantaciones en <strong>México, Guatemala, Honduras, Nicaragua y Costa Rica</strong>.
                Mi misión es acompañar a productores en cada etapa de su proyecto para lograr plantaciones sanas, productivas y sostenibles.
              </p>

              <div className="expert-action-wrapper">
                <Link to="/servicios" className="expert-profile-btn">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="btn-user-icon">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                  <span>Más sobre mí</span>
                </Link>
                <Link to="/contacto" className="expert-quick-contact-btn">
                  <span>Agendar Consulta</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4 Value Pillars Bar matching reference image */}
      <section className="value-pillars-bar">
        <div className="container">
          <div className="pillars-grid">
            <div className="pillar-item">
              <div className="pillar-icon-circle">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8z" />
                </svg>
              </div>
              <div className="pillar-text">
                <h4>Experiencia</h4>
                <p>Años de trabajo en campo y en asesoría técnica especializada.</p>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-circle">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <div className="pillar-text">
                <h4>Soluciones Personalizadas</h4>
                <p>Estrategias adaptadas a cada finca y necesidad.</p>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-circle">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 22v-9" />
                  <path d="M9 15c-3-1-5.5-4-5.5-7.5C3.5 4 6.5 2 12 2s8.5 2 8.5 5.5c0 3.5-2.5 6.5-5.5 7.5" />
                </svg>
              </div>
              <div className="pillar-text">
                <h4>Sostenibilidad</h4>
                <p>Prácticas responsables con el ambiente y tu inversión.</p>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-circle">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m11 17 2 2a1 1 0 0 0 1.42 0l4.24-4.24a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.42 0L11 13.58" />
                  <path d="m7 13 4 4" />
                  <path d="M16.5 6.5 19 9a2.5 2.5 0 0 1 0 3.5l-1 1-5-5 1-1a2.5 2.5 0 0 1 3.5 0Z" />
                  <path d="m2 14.5 5.5 5.5a2.5 2.5 0 0 0 3.5 0l1-1-5-5-1 1a2.5 2.5 0 0 1-3.5 0l-.5-.5Z" />
                </svg>
              </div>
              <div className="pillar-text">
                <h4>Acompañamiento</h4>
                <p>Te guiamos en cada paso de tu proyecto.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="home-section about-us-section" id="about-us-bg">
        <div className="container">
          <div className="about-us-grid">
            <div className="about-us-image-wrap">
              <img src="/field3.jpeg" alt="Plantación de vainilla en Costa Rica" className="about-img" />
              <div className="about-image-badge">
                <span>100% Costarricense</span>
              </div>
            </div>
            <div className="about-us-content-card">
              <span className="section-kicker">CON VAINILLA SIEMPRE SÍ</span>
              <h2>Pasión por la Vainilla Auténtica</h2>
              <p>
                En Sol de Vainilla, cultivamos y procesamos vainilla con dedicación y respeto por la tradición. Nuestra vainilla (<em>Vanilla planifolia</em>) crece en las ricas tierras de Costa Rica, bajo el cálido sol y la humedad perfecta, lo que le confiere un aroma y sabor excepcionales.
              </p>
              <p>
                Nos comprometemos con prácticas sostenibles para asegurar la calidad de nuestros productos y el bienestar de nuestro entorno. Desde la polinización a mano hasta el beneficiado lento y cuidadoso, cada etapa de nuestro proceso se realiza con la máxima atención al detalle.
              </p>
              <div className="about-actions">
                <Link to="/productos" className="about-primary-btn">Explorar Productos</Link>
                <Link to="/servicios" className="about-secondary-btn">Servicios </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Preview */}
      <section className="home-section benefits-preview-section">
        <div className="container">
          <div className="benefits-header">
            <span className="section-kicker">PUREZA Y BIENESTAR</span>
            <h2>Más que un Sabor Delicioso</h2>
            <p>Descubre algunas de las razones para elegir la vainilla 100% costarricense de Sol de Vainilla:</p>
          </div>

          <div className="benefits-cards-grid">
            <div className="benefit-card">
              <div className="benefit-img-box">
                <img src="/aroma.jpeg" alt="Aroma Natural y Relajante" />
              </div>
              <h3>Aroma Natural y Relajante</h3>
              <p>Disfruta de un aroma puro que evoca calidez, frescura y bienestar botánico en cada creación.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-img-box">
                <img src="/antioxidantes.jpeg" alt="Calidad Respaldada por Ciencia" />
              </div>
              <h3>Calidad Respaldada por Ciencia</h3>
              <p>Propiedades antioxidantes y pureza química garantizada por nuestro trabajo en biotecnología.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-img-box">
                <img src="/vainillapura.jpeg" alt="Cultivo 100% Sostenible" />
              </div>
              <h3>Cultivo 100% Sostenible</h3>
              <p>Prácticas agrícolas responsables que protegen la biodiversidad de nuestras tierras en Costa Rica.</p>
            </div>
          </div>

          <div className="benefits-action">
            <Link to="/beneficios" className="benefits-view-all-btn">Ver todos los Beneficios</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;